import React, { useState,useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { useMediaQuery } from 'react-responsive';

import UploadFileItem from '../../Components/UploadFileItem';

const DocumentModal = ({
  visible,
  onHide,
  documentTypes = [],
  onSubmit,
  setAlert,
  setAlertTitle,
  setAlertBody,
  showSuccessToast,
  showErrorToast,
  retrieveItemsList
}) => {
  const [form, setForm] = useState({
    documentType: null,
    files: []
  });

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [saving, setSaving] = useState(false);

const [tempFiles, setTempFiles] = useState([]);
const [uploadedFiles, setUploadedFiles] = useState([]);

const fileUploadRef = useRef(null);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };


const handleClose = () => {
    onHide();
    fileUploadRef.current?.clear();
    setForm({
      documentType: null,
        files: []
    });
    setTempFiles([]);
    setUploadedFiles([]);
};


const handleSubmit = () => {

  if (!form.documentType) {
    setAlertTitle("Tipo de documento obrigatório");
    setAlertBody("Selecione o tipo de documento a ser enviado.");
    setAlert(true);
    return;
  }

  if (!uploadedFiles || uploadedFiles.length === 0) {
    setAlertTitle("Arquivos obrigatórios");
    setAlertBody("Você precisa selecionar ao menos um arquivo.");
    setAlert(true);
    return;
  }

    const formData = new FormData();

    if (form.documentType && uploadedFiles.length > 0) {
        uploadedFiles.forEach((fileObj) => {
            const file = fileObj?.file instanceof File ? fileObj.file : fileObj;

            if (file instanceof File) {
            // ⚠️ Adiciona arquivo no formato que o backend espera
            formData.append("companyComprobationFiles", file, file.name);

            // ⚠️ Adiciona metadados do arquivo correspondente
            const metadata = JSON.stringify({
                documentType: form.documentType,
                documentName: file.name
            });
            formData.append("companyComprobationFilesMetadata", metadata);
            }
        });
    }

  setSaving(true);

    try {
    onSubmit(
        formData,
        () => {
        setSaving(false);
        showSuccessToast("Documento enviado", "Documento salvo com sucesso.");
        retrieveItemsList();
        handleClose();
        },
        (msg) => {

        setSaving(false);
        showErrorToast("Erro ao enviar documento", msg);
        }
    );
    } catch (error) {
    setSaving(false);
    showErrorToast("Erro ao enviar documento", error.message || "Ocorreu um erro inesperado.");
    }

};

const handleRemoveUploaded = (index) => {
  setUploadedFiles(prev => prev.filter((_, i) => i !== index));
};

  return (
    <Dialog visible={visible} onHide={handleClose} header="Adicionar Documento" style={{ width:isMobile ? '100vw' : '50vw',height:isMobile ? '95vh' : '80vh',maxWidth:'900px' }} dismissableMask>
      <div className="flex-column" style={{ gap: '1rem' }}>
        <div className="w100 tAlignL formControl">
          <label htmlFor="documentType">Tipo de documento <span className="requiredField">*</span></label>
          <Dropdown
            id="documentType"
            value={form.documentType}
            options={documentTypes}
            onChange={(e) => handleChange('documentType', e.value)}
            placeholder="Selecione o tipo de documento"
            style={{width:"50%"}}
          />
        </div>

        <div className="w100 tAlignL formControl">
          <label htmlFor="documentFiles">Arquivos <span className="requiredField">*</span></label>
            <FileUpload
            ref={fileUploadRef}
            name="documentFiles"
            mode="advanced"
            multiple
            customUpload
            accept=".jpg,.png,.pdf"
            maxFileSize={5000000}
            chooseLabel="Selecionar arquivos"
            uploadLabel="Confirmar envio"
            cancelLabel="Cancelar envio"
            disabled={!form.documentType}
            className={!form.documentType ? 'hide-buttons' : ''}
            invalidFileSizeMessageSummary="Arquivo muito grande"
            invalidFileSizeMessageDetail="O tamanho máximo do arquivo é de 5MB."
            uploadHandler={() => {
                if (!tempFiles || tempFiles.length === 0) {
                    showErrorToast("Erro", "Nenhum arquivo foi selecionado.");
                    return;
                }

                setUploadedFiles(prev => [...prev, ...tempFiles]);
                setTempFiles([]);

                // ✅ Limpa visualmente o componente FileUpload
                fileUploadRef.current?.clear();

                showSuccessToast("Arquivos adicionados", "Arquivos prontos para envio.");
            }}
            onClear={() => {
                setTempFiles([]);                
                /*setTimeout(() => {
                    fileUploadRef.current?.clear();
                }, 0);*/
            }}
            onSelect={(e) => {
                const filesUploaded = e.files || [];
                const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
                const validFiles = filesUploaded.filter(file => allowedTypes.includes(file.type));

                if (validFiles.length !== filesUploaded.length) {
                showErrorToast("Arquivo inválido", "Apenas PDF, JPG e PNG são permitidos.");
                }

                setTempFiles(validFiles);
            }}
            emptyTemplate={!form.documentType ? (
                <p className="m-0">Selecione o tipo de documento primeiro.</p>
            ) : (
                <p className="m-0">Arraste e solte ou clique para selecionar os arquivos.</p>
            )}
            itemTemplate={(file, props) => (
            <UploadFileItem file={file} index={props.index} onRemove={props.onRemove} />
            )}            
            />

            {uploadedFiles.length > 0 && (
            <div className="uploaded-file-list" style={{ marginTop: '1rem' }}>
                <h4>Arquivos prontos para envio</h4>
                <div className="flex-column" style={{ gap: '0.5rem' }}>
                {uploadedFiles.map((file, index) => (
                    <div
                    key={index}
                    className="flex-row align-items-center justify-between"
                    style={{ padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px' }}
                    >
                    <div className="flex-row align-items-center justify-start gap-1">
                        {file.type.startsWith('image/') ? (
                        <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                        />
                        ) : (
                        <i className="pi pi-file" style={{ fontSize: '1.5rem', color: '#888' }} />
                        )}
                        <div className="flex-column">
                        <b>{file.name}</b>
                        <small>{(file.size / 1024).toFixed(1)} KB</small>
                        </div>
                    </div>
                    <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-danger"
                        onClick={() => handleRemoveUploaded(index)}
                    />
                    </div>
                ))}
                </div>
            </div>
            )}

        </div>

        <div className="flex-row justify-end" style={{ gap: '0.5rem' }}>
          <Button label="Cancelar" onClick={handleClose} className="textButton" />
          <Button label="Salvar" loading={saving} onClick={handleSubmit} className="filledButton" />
        </div>
      </div>
    </Dialog>
  );
};

export default DocumentModal;
